export default {
  path: '/documents',
  component: {
    render: h => h('router-view'),
  },
  children: [
    {
      path: '/documents/public-files',
      component: () => import('./public-files/public-files'),
    },
    {
      path: '/documents/translation-center',
      component: () => import('./translation-center/translation-center'),
    },
  ],
}
